/**
 * Set - комплект товаров
 */

export const set = {
    namespaced: true,
    state: () => ({
        items: {
            A: null,
            B: null,
            C: null,
            D: null,
        },
        price: 0,
        price_for_pack: 0,
        qty_per_pack: 1,
    }),
    mutations: {
        setItem: (state, payload) => {
            state.items = {
                ...state.items,
                ...payload
            };
        },
    },
    actions: {        
        setItem: ({ dispatch, commit }, payload) => {
            commit('setItem', payload);
        },
    },
    getters: {
    }
}